define('casino/winners',['jquery'], function($) {
	'use strict';

	var initialized = false;
	var FADE_IN_SPEED = 1000;
	var $winners;

	function hideMoreLinkIfAllShown() {
		if ($winners.find('.post:hidden').length === 0) {
			$winners.find('#casino-winners-more').hide();
		}
	}

	function showMore() {
		var howMany = $(this).data('max');

		var $winners = $('#casino-winners');
		var $hidden = $winners.find('.post:hidden').slice(0, howMany);
		$hidden.fadeIn(FADE_IN_SPEED);
		hideMoreLinkIfAllShown();
	}

	function setupShowMoreLink() {
		$('#casino-winners-more').click(showMore);
	}

	function init() {
		if(initialized) {
			return;
		}
		initialized = true;
		$winners = $('#casino-winners');

		$winners.find('.post').each(function() {
			var $t = $(this);
			var gameId = $t.data('game');
			$t.populate(gameId, {onlyIcon: true});
		});
		setupShowMoreLink();
	}

	var casinoWinners = {
		init: init
	};

	return casinoWinners;

});

